import { gql } from '../../__generated'

export const GET_GRID_DISTRIBUTION_BOX_QUERY = gql(/* GraphQL */ `
  fragment gridDistributionCircuitFragment on GridDistributionCircuit {
    circuitId
    name
    description
    label
    device {
      deviceId
      type
      data {
        key
        value
      }
      name
      status
      source
    }
  }
  query GetGridDistributionBox($distributionBoxId: ID!) {
    getGridDistributionBox(distributionBoxId: $distributionBoxId) {
      name
      description
      distributionBoxId
      parent {
        name
      }
      building {
        name
      }
      device {
        deviceId
        type
      }
      maxPower
      maxCurrent
      maxPowerPerPhase
      maxCurrentPerPhase
      circuits {
        ...gridDistributionCircuitFragment
        parent {
          ...gridDistributionCircuitFragment
          parent {
            ...gridDistributionCircuitFragment
            parent {
              ...gridDistributionCircuitFragment
            }
          }
        }
      }
    }
  }
`)

/*
Uit GetGridDistributionBox:
mainCircuit {
          circuitId
          name
          device {
            deviceId
            name
            type
            status
            source
          }
        }
 */
